<template>
  <div class="wrapper">
    <el-tabs v-model="activeName">
      <el-tab-pane label="本次成绩" name="first">
        <h3>考试者：{{ userData.name }}</h3>
        <p class="greyFont">
          开始时间：{{ submitData.startTime }} | 交卷时间:
          {{ submitData.endTime }}
        </p>
        <div class="scoreBar">
          <div class="total">
            <div class="redFont bigFont">{{ submitData.totalScore }}</div>
            <div>试卷总分</div>
          </div>
          <div class="myScore">
            <el-progress
              type="circle"
              :format="format"
              :color="scoreRateList"
              :percentage="
                parseInt(
                  (submitData.studentScore / submitData.totalScore) * 100
                ) || 0
              "
            ></el-progress>
          </div>
          <div class="time">
            <div class="redFont bigFont">
              {{ parseInt(submitData.consumeTime / 60) }}
              <span class="miniFont">分</span>
              {{ submitData.consumeTime % 60 }}
              <span class="miniFont">秒</span>
            </div>
            <div>用时</div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="答题分析" name="second">
        <el-radio-group v-model="qestionShowType">
          <el-radio-button label="错题"></el-radio-button>
          <el-radio-button label="答对"></el-radio-button>
          <el-radio-button label="未答"></el-radio-button>
          <el-radio-button label="全部试题"></el-radio-button>
        </el-radio-group>
        <div class="questionBox">
          <div
            class="questionCell"
            v-for="(qst, qstIdx) in questionShowList"
            :key="'question' + qst.id"
          >
            <div class="qstTitle">
              <span class="blueFont">{{ qstIdx + 1 }}、[{{ qst.type }}]</span>
              {{ qst.content | removeTag }}
            </div>
            <div
              class="aswBar"
              v-for="asw in qst.answerDTOList"
              :key="'asw' + asw.id"
            >
              {{ String.fromCharCode(asw.showNo + 64) }}、
              {{ asw.content | removeTag }}
            </div>
            <div class="qstConditionBar">
              <div class="myAsw">
                <div class="aswTitle">
                  考生答案
                  <i
                    :class="[
                      qst.ifCorrect ? 'el-icon-check' : 'el-icon-close',
                      qst.ifCorrect ? 'greenFont' : 'redFont',
                    ]"
                  ></i>
                </div>

                <div
                  v-if="
                    qst.questionTypeId == 1 ||
                    qst.questionTypeId == 2 ||
                    qst.questionTypeId == 5
                  "
                >
                  {{
                    qst.answerDTOList
                      .filter((item) =>
                        qst.studentChooseList.includes(String(item.id))
                      )
                      .map((item) => String.fromCharCode(item.showNo + 64))
                      .join(",")
                  }}
                </div>
                <div v-if="qst.questionTypeId == 3">
                  <div v-for="asw in qst.studentChooseList" :key="asw">
                    {{ asw }}
                  </div>
                </div>
              </div>
              <div class="correctAsw">
                正确答案<br />
                <span
                  v-if="
                    qst.questionTypeId == 1 ||
                    qst.questionTypeId == 2 ||
                    qst.questionTypeId == 5
                  "
                  >{{
                    qst.answerDTOList
                      .filter((item) => item.isCorrect == 1)
                      .map((item) => String.fromCharCode(item.showNo + 64))
                      .join(",")
                  }}</span
                >
                <div v-if="qst.questionTypeId == 3">
                  <div v-for="asw in qst.answerDTOList" :key="'asw' + asw.id">
                    {{ asw.content }}
                  </div>
                </div>
              </div>
              <div class="score">
                分数:<br />
                <span class="blueFont"
                  >{{ qst.giveScore || 0 + "/" + qst.score }}分</span
                >
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="后台监考" name="third">
        <div class="stepBox">
          <div class="stepCell">
            <div class="stepTitle">{{ submitData.startTime }}</div>
            <div class="stepDivide"></div>
            <div class="stepDetail">开始考试 IP:14.127.249.62</div>
          </div>
          <div
            class="stepCell"
            v-for="(item, index) in submitData.urlDTOList"
            :key="'cheat' + index"
          >
            <div class="stepTitle">{{ item.currentDate }}</div>
            <div class="stepDivide">
              <div class="brige"></div>
            </div>
            <div class="stepDetail">
              {{ item.description }}
              &nbsp;
              <el-image
                class="stepIcon"
                v-if="item.url"
                :src="item.url"
                :preview-src-list="[item.url]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture"></i>
                </div>
              </el-image>
            </div>
          </div>
          <div class="stepCell">
            <div class="stepTitle">{{ submitData.endTime }}</div>
            <div class="stepDivide"><div class="brige"></div></div>
            <div class="stepDetail">结束考试</div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      qestionShowType: "错题",
      percentage: 0,
      scoreRateList: [
        { color: "red", percentage: 60 },
        { color: "green", percentage: 60 },
      ],
    };
  },
  props: {
    submitData: Object,
    userData: Object,
  },
  computed: {
    questionShowList() {
      let returnList = [];
      switch (this.qestionShowType) {
        case "错题":
          returnList = this.submitData.errorList;
          break;
        case "答对":
          returnList = this.submitData.correctList;
          break;
        case "未答":
          returnList = this.submitData.unAnsweredList;
          break;
        case "全部试题":
          returnList.push(
            ...this.submitData.correctList,
            ...this.submitData.errorList
          );
          break;
        default:
          break;
      }
      return returnList;
    },
  },
  filters: {
    removeTag(content) {
      return content.replace(/<[^>]+>/g, "");
    },
  },
  created() {},
  mounted() {},
  methods: {
    format(percentage) {
      console.log(percentage);
      return this.submitData.studentScore + "分";
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .scoreBar {
    width: 70%;
    display: flex;
    margin: auto;
    justify-content: space-between;
    text-align: center;
    margin-top: 40px;
    .total {
    }
    .myScore {
      width: 200px;
    }
    .time {
    }
  }
  .questionBox {
    min-height: 20vh;
    max-height: 45vh;
    overflow: scroll;
    .questionCell {
      border-bottom: 1px solid #ccc;
      padding: 20px 0 0 0;

      .qstTitle {
      }
      .aswBar {
      }
      .qstConditionBar {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;
        .myAsw {
          .aswTitle {
            display: flex;
            align-items: center;
            i {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
  .stepBox {
    .stepCell {
      display: flex;
      align-items: center;
      height: 24px;
      .stepTitle {
        width: 160px;
        text-align: right;
      }
      .stepDivide {
        width: 11px;
        height: 11px;
        border-radius: 5px;
        margin: 0 10px;
        background: #36aafd;
        position: relative;
        .brige {
          position: absolute;
          left: 5px;
          bottom: 0;
          height: 24px;
          width: 1px;
          background: #36aafd;
        }
      }
      .stepDetail {
        flex: 1;
        display: flex;
        align-items: center;
        /deep/ .image-slot {
          height: 100%;
          width: 100%;
          line-height: 24px;
        }
        .stepIcon {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>
